var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input-discount",attrs:{"aria-label":"Поле ввода скидки в рублях","type":"text","disabled":_vm.disabled},domProps:{"value":_vm.inputValue},on:{"blur":_vm.onBlur,"focus":function($event){_vm.isFocused = true},"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }